import { List as MuiList } from "@mui/material";

export const List = MuiList;
